module.exports = __webpack_public_path__ + "static/media/facebook.105eed27.jpg";